import { subDays } from 'date-fns';

import { date } from '@/utils/filters';

import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import columns from './columns';
import learner from './learner';
import filters from './filters';

const namespaced = true;

const state = {
  learners: [],
  learnersFilters: {},
  columns,
  creditsUnit: 'credits',
  pageSize: 15,
  currentPage: 0,
  ordering: null,
  dateRange: {
    start: date(subDays(new Date(), 30)),
    end: date(new Date()),
  },
};

export default {
  namespaced,
  getters,
  actions,
  mutations,
  state,
  modules: {
    filters,
    learner,
  },
};
